// "needed by Nov 19", red with "12 days late" once an open PO is past it: the same words on every PO list.
import type { Po } from "../../../../shared/db.gen.ts";
import { dayText, plural } from "../../lib/format.ts";
import { cx } from "../../ui/controls.tsx";
import { daysLate } from "./lib.ts";

export function NeededBy({ po, prefix = " · ", className }: { po: Pick<Po, "status" | "expected_arrive">; prefix?: string; className?: string }) {
  if (!po.expected_arrive) return null;
  const late = daysLate(po);
  return (
    <span className={cx(late > 0 && "text-danger", className)}>
      {prefix}needed by {dayText(po.expected_arrive)}
      {late > 0 && ` · ${plural(late, "day")} late`}
    </span>
  );
}
